import './CoverDescription.css';
import { SanitizedHtml } from '../../shared/components/sanitizedHtml/SanitizedHtml';
import { renderTextWithLineBreaks } from '../../shared/util/renderTextWithLineBreaks';

export interface CoverDescriptionProps {
  description?: string;
}

// The admin rich text editor always emits markup starting with a tag, while
// legacy descriptions are plain strings.
const isRichText = (description: string): boolean => description.trimStart().startsWith('<');

export function CoverDescription({ description }: CoverDescriptionProps): JSX.Element | null {
  if (!description) return null;

  if (isRichText(description)) {
    return <SanitizedHtml html={description} className="cover-description fs-mask" />;
  }

  return <p className="cover-description fs-mask">{renderTextWithLineBreaks(description)}</p>;
}
